storefrontApp.service("creditCardService", [
    "$http",
    function ($http) {
        var regVisa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
        var regMaster = new RegExp("^5[1-5][0-9]{14}$");
        var regAMEX = new RegExp("^3[47][0-9]{13}$");
        var regDiscover = new RegExp("^6(?:011|5[0-9]{2})[0-9]{12}$");
        var regDiners = new RegExp("^3(?:0[0-5]|[68][0-9])[0-9]{11}$");
        var regJCB = new RegExp("^(?:2131|1800|35\\d{3})\\d{11}$");

        return {
            getCreditCardType: function (cardNumber) {
                if (cardNumber !== undefined) {
                    cardNumber = cardNumber.replace(/[\s]/g, "");

                    if (regVisa.test(cardNumber)) return "VISA";
                    else if (regMaster.test(cardNumber)) return "MASTER";
                    else if (regAMEX.test(cardNumber)) return "AMEX";
                    else if (regDiscover.test(cardNumber)) return "DISCOVER";
                    else if (regDiners.test(cardNumber)) return "DINERS";
                    else if (regJCB.test(cardNumber)) return "JCB";
                    else return null;
                }
                return null;
            },

            formatCardNumberWithSpaces: function (cardNumber) {
                return (
                    cardNumber &&
                    cardNumber
                        .substring(0, 19)
                        .replace(/(\d{4})(\d+)/g, "$1 $2")
                );
            },

            cardNumberWithoutSpaces: function (cardNumber) {
                return cardNumber && cardNumber.replace(/[\s]/g, "");
            },

            getExpiryDate: function (month, year) {
                return month && year && month + "/" + year.substring(2);
            },

            getCreditCards: function (userId) {
                return $http.get(
                    "storefrontapi/getcards?userId=" +
                        userId +
                        "&t=" +
                        Date.now()
                );
            },

            addCard: function (newCard) {
                return $http.post("storefrontapi/insertcard", newCard);
            },

            updateCard: function (updatedCard) {
                return $http.post("storefrontapi/updatecard", updatedCard);
            },

            deleteCard: function (id) {
                return $http.delete("storefrontapi/deletecard?creditId=" + id);
            },
        };
    },
]);
